export enum Unit {
    PIECE = 1,
    METER = 2,
    KILO = 3,
    PACKAGE = 4,
}
